import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { PATH_LANG } from './langPath';

// Import your translation files
import en from './locales/en.json';
import hu from './locales/hu.json';
import ro from './locales/ro.json';
import de from './locales/de.json';

const SUPPORTED_LANGUAGES = ['en', 'hu', 'ro', 'de'];

// Detect the initial language:
// 1. /hu, /ro or /de path prefix (authoritative for that URL tree)
// 2. ?lang= query parameter (legacy links; redirected to /hu below)
// 3. language previously chosen by the visitor (localStorage)
// 4. browser language
// 5. fallback to English
function detectLanguage() {
  // 1. The URL path prefix (/hu/...) is authoritative. It must outrank stored
  //    and browser preferences, otherwise a /hu page would flip to the
  //    visitor's own language on hydration and contradict its own canonical.
  if (PATH_LANG && SUPPORTED_LANGUAGES.includes(PATH_LANG)) {
    return PATH_LANG;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    const urlLang = (params.get('lang') || '').toLowerCase();
    if (SUPPORTED_LANGUAGES.includes(urlLang)) {
      return urlLang;
    }
    const storedLang = window.localStorage.getItem('lang');
    if (SUPPORTED_LANGUAGES.includes(storedLang)) {
      return storedLang;
    }
    const browserLang = (navigator.language || '').split('-')[0].toLowerCase();
    if (SUPPORTED_LANGUAGES.includes(browserLang)) {
      return browserLang;
    }
  } catch (e) {
    // ignore and fall back to English
  }
  return 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hu: { translation: hu },
      ro: { translation: ro },
      de: { translation: de }
    },
    lng: detectLanguage(),
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false
    }
  });

// Set <html lang> for the initially detected language (the languageChanged
// handler below only fires on subsequent switches).
try {
  document.documentElement.setAttribute('lang', i18n.language.split('-')[0]);
} catch (e) {
  // document unavailable - ignore
}

// Persist the visitor's language choice and keep <html lang> in sync
i18n.on('languageChanged', (lng) => {
  try {
    // A language implied by the URL path is a property of the document, not a
    // stated preference - don't let it overwrite what the visitor chose.
    if (!(PATH_LANG && lng === PATH_LANG)) {
      window.localStorage.setItem('lang', lng);
    }
    document.documentElement.setAttribute('lang', lng);
  } catch (e) {
    // localStorage unavailable (private mode) - ignore
  }
});

export default i18n;
